import { Component, Input, OnDestroy } from '@angular/core';
import { QueryService } from '../../comun/services/query.service';
import { GlobalConstants } from '../../global-constants';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { WebsocketService } from '../../comun/services/websocket.service';

@Component({
  selector: 'app-perfil-acciones',
  templateUrl: './perfil-acciones.component.html',
  styleUrl: './perfil-acciones.component.css'
})
export class PerfilAccionesComponent implements OnDestroy {
  @Input() misdatos!: any;
  @Input() perfil!: any;
  private wsSubscription?: Subscription;

  // Sincronización local de amistades con el modal (compatible con Angular Elements).
  private readonly onAmistadesActualizadas = (event: Event): void => {
    const detalle = (event as CustomEvent<{ userId: number }>).detail;
    const conectado = Number(this.misdatos?.ID);
    const visitado = Number(this.perfil?.ID);
    if (!detalle || !conectado || conectado !== visitado ||
        Number(detalle.userId) !== conectado) return;

    this.numeroAmigos();
    this.numeroSolicitudes();
  };

  constructor(private wsService: WebsocketService,
              private query: QueryService) { }

  ngOnInit() {
    window.addEventListener('iguau:amistades-actualizadas', this.onAmistadesActualizadas);
    // WebSocket Nos quedamos escuchando de forma persistente
    this.wsSubscription = this.wsService.escucharNotificaciones().subscribe({
      next: (data) => {
        if ((data.tipo == 'CHAT_NUEVOMENSAJE' && data.user_to == this.misdatos.ID) || (data.tipo == 'CHAT_LEERMENSAJES' && data.user_from == this.misdatos.ID)) {
          this.numeroMensajes();
        }
      },
      error: (err) => console.error(err),
    });
    this.numeroMensajes();
    this.numeroNotificaciones();
    this.numeroAmigos();
    this.numeroSolicitudes();
    this.numeroVisitas();
  }

  ngOnDestroy(): void {
    window.removeEventListener('iguau:amistades-actualizadas', this.onAmistadesActualizadas);
    this.wsSubscription?.unsubscribe();
  }

  numeroMensajes() {
    if (this.misdatos.ID != this.perfil.ID)
      return;
    this.query.query('mensajes', 'NUMEROMENSAJESSINLEER', null).subscribe((resultado:any) => {
      this.perfil.datos.mensajes = resultado.numero;
    });
  }

  numeroNotificaciones() {
    if (this.misdatos.ID != this.perfil.ID)
      return;
    /*this.query.query('buzon', 'NUMERO', { ID: this.misdatos.ID }).subscribe((resultado:any) => {
      this.datos.notificaciones = resultado.numero;
      this.datos.notificaciones_total = resultado.total;
    });*/
    // Obtener los mensajes en firebase
    /*this.chatService.obtenerMensajesParaMi(this.misdatos.ID.toString(), 'COMPARTIR_PERFIL')
      .subscribe(mensajes => {
        // Esto se ejecuta cada vez que recibes un mensaje
        this.perfil.datos.notificaciones = mensajes.length;
      });*/
  }

  numeroAmigos() {
    this.query.query('seguir', 'NUMERO', { se_us_id_to: this.perfil.ID, se_estado: 'activo' }).subscribe((resultado:any) => {
      this.perfil.datos.amigos = resultado.numero;
    });
  }

  numeroSolicitudes() {
    if (this.misdatos.ID != this.perfil.ID)
      return;
    // Solicitudes pendientes de aceptar de otros usuarios    
    this.query.query('seguir', 'NUMERO', { se_us_id_to: this.misdatos.ID, se_estado: 'pendiente' }).subscribe((resultado:any) => {      
      this.perfil.datos.solicitudes = Number(resultado.numero);
    });
  }

  numeroVisitas() {
    this.query.query('visita', 'NUMERO', { ID: this.perfil.ID }).subscribe((resultado:any) => {      
      this.perfil.datos.visitas_total = resultado.total;
      this.perfil.datos.visitas_nuevas = resultado.nuevas;
    });
  }

  seguir() {
    let pregunta = '';
    if (this.perfil.losigo == '')
      pregunta = '¿Quieres enviar solicitud de amistad a este perfil?';
    else if (this.perfil.losigo == 'pendiente')
      pregunta = '¿Quieres cancelar la solicitud de amistad a este perfil?';
    else if (this.perfil.losigo == 'activo')
      pregunta = '¿Quieres dejar de ser amigo de este perfil?';
    Swal.fire({
      title: 'Confirmación',
      text: pregunta,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        /*cancelButton: 'custom-swal-cancel'*/
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.query.query('seguir', 'SEGUIR', { se_us_id: this.misdatos.ID, se_us_id_to: this.perfil.ID }).subscribe((resultado:any) => {
          this.perfil.losigo = resultado.estado;
          this.numeroAmigos();
          this.enviarNotificacion('SEGUIR');
        });
      } else {
      }
    });
  }

  dejarHuella() {
    this.query.query('huellas', 'HUELLA', { tipo: 'PE', tipo_id: this.perfil.ID }).subscribe((resultado:any) => {
      if (this.perfil.mihuella == 0) {
        this.perfil.mihuella = 1;
        ++this.perfil.huellas;
      } else {
        this.perfil.mihuella = 0;
        --this.perfil.huellas;
      }
    });
  }

  enviarNotificacion(cual: string = '') {
    if (cual == 'SEGUIR') {
      let texto = '<b>' + this.misdatos.first_name + '</b> te ha enviado una solicitud de amistad';
      let params = { plantilla: 'general.html',
                    us_id_from: this.misdatos.ID,
                    us_id: this.perfil.ID,
                    tipo: 'ACTIVIDAD',
                    asunto: 'Amistad en iGuau',
                    contenido: '',
                    texto: texto,
                    botonurl: GlobalConstants.urlWeb,
                    boton: 'Ir a iGuau',
                    estado: 'pendiente',
                    contacto: '' // al email de contacto del usuario
                  };
      this.query.enviarMail(params).subscribe((resultado:any) => {
      });
    }
  }
}
